<template>
  <div class="b-default-page">
    <template>
      <slot></slot>
    </template>
    <template v-if="loading">
      <div class="b-default-page-box" :style="positionFixed">
        <!--loading animate-->
        <div class="loading-animate" v-if="loadingType === 'line'">
          <div class="line"></div>
          <div class="line"></div>
          <div class="line"></div>
          <div class="line"></div>
          <div class="line"></div>
        </div>
        <div class="loading-css" v-else></div>
        <div class="tips">
          {{ tipsName }}
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'BLoading',
  props: {
    loading: [String, Number, Boolean, Array, Object, Date, Function, Symbol],
    loadingType: {
      type: String,
      default: 'line'
    },
    tips: {
      type: String,
      default: '内容加载中'
    },
    position: {
      type: Array,
      default: () => {
        return [0, 0, 0, 0]
      }
    }
  },
  computed: {
    tipsName() {
      return this.tips || '内容加载中'
    },
    positionFixed() {
      if (Array.isArray(this.position) && this.position.length === 4) {
        return {
          top: typeof this.position[0] === 'number' ? `${this.position[0]}px` : this.position[0],
          right: typeof this.position[1] === 'number' ? `${this.position[1]}px` : this.position[1],
          bottom: typeof this.position[2] === 'number' ? `${this.position[2]}px` : this.position[2],
          left: typeof this.position[3] === 'number' ? `${this.position[3]}px` : this.position[3],
        }
      }
      return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
      }
    }
  }
}
</script>

<style lang="less" scoped>
.b-default-page {
  //position: fixed;
  //top: 0;
  //right: 0;
  //bottom: 0;
  //left: 0;
  //background: #FFFFFF;
  //overflow-y: auto;

  .b-default-page-box {
    background: #FFFFFF;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 100;

    .tips {
      position: absolute;
      top: 43%;
      left: 50%;
      transform: translate(-50%, 16%);
      font-size: 16px;
      color: #666;
    }

    .image-icon {
      // width: 180px;
      cursor: auto;
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      display: flex;
      justify-content: center;
      align-items: center;

      image {
        display: block;
        width: 100%;
      }
    }
  }
}

.loading-animate {
  position: absolute;
  top: 40%;
  left: 50%;
  transform: skewX(-14deg) translate(-50%, -50%);
  width: 68px;

  .line {
    display: block;
    bottom: 0;
    width: 6px;
    height: 10px;
    background: #f4f6fb;
    position: absolute;
    -webkit-animation: loading_animation 1.5s infinite ease-in-out;
    -moz-animation: loading_animation 1.5s infinite ease-in-out;
    -ms-animation: loading_animation 1.5s infinite ease-in-out;
    -o-animation: loading_animation 1.5s infinite ease-in-out;
    animation: loading_animation 1.5s infinite ease-in-out;

  }

  .line:nth-child(2) {
    left: 15px;
    -webkit-animation-delay: .2s;
    -moz-animation-delay: .2s;
    -ms-animation-delay: .2s;
    -o-animation-delay: .2s;
    animation-delay: .2s;

  }

  .line:nth-child(3) {
    left: 30px;
    -webkit-animation-delay: .4s;
    -moz-animation-delay: .4s;
    -ms-animation-delay: .4s;
    -o-animation-delay: .4s;
    animation-delay: .4s;
  }

  .line:nth-child(4) {
    left: 45px;
    -webkit-animation-delay: .6s;
    -moz-animation-delay: .6s;
    -ms-animation-delay: .6s;
    -o-animation-delay: .6s;
    animation-delay: .6s;
  }

  .line:nth-child(5) {
    left: 60px;
    -webkit-animation-delay: .8s;
    -moz-animation-delay: .8s;
    -ms-animation-delay: .8s;
    -o-animation-delay: .8s;
    animation-delay: .8s;
  }
}


@keyframes loading_animation {
  0% {
    height: 5px;
    transform: translateY(0px);
    background: #f4f6fb;
  }

  25% {
    height: 30px;
    transform: translateY(15px);
    background: #45d4a8;
  }

  50% {
    height: 5px;
    transform: translateY(0px);
    background: #f4f6fb;
  }

  100% {
    height: 5px;
    transform: translateY(0px);
    background: #f4f6fb;
  }
}

.loading-css {
  box-sizing: border-box;
  width: 80px;
  height: 80px;
  display: inline-block;
  border: 10px solid #f3f3f3;
  border-top: 10px solid rgba(250, 204, 57, 0.7);
  border-radius: 50%;
  /* 动画旋转效果 */
  animation: rotate-360 1s infinite linear;
}

@keyframes rotate-360 {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
